import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LocationIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LocationIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.9998 13.8342C10.0505 13.8342 8.46468 12.2483 8.46468 10.2991C8.46468 8.34937 10.0505 6.76351 11.9998 6.76351C13.9495 6.76351 15.5354 8.34937 15.5354 10.2991C15.5354 12.2483 13.9495 13.8342 11.9998 13.8342ZM11.9998 8.28023C10.8869 8.28023 9.98142 9.18573 9.98142 10.2991C9.98142 11.412 10.8869 12.3175 11.9998 12.3175C13.1131 12.3175 14.0186 11.412 14.0186 10.2991C14.0186 9.18573 13.1131 8.28023 11.9998 8.28023Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9998 22C11.8541 22 11.708 21.958 11.5811 21.8741C11.2592 21.6608 3.70068 16.5848 3.70068 10.2991C3.70068 5.72272 7.4234 2 11.9998 2C16.5762 2 20.2994 5.72272 20.2994 10.2991C20.2994 16.5848 12.7404 21.6608 12.4185 21.8741C12.2916 21.958 12.1454 22 11.9998 22ZM11.9998 3.51674C8.25978 3.51674 5.21742 6.5591 5.21742 10.2991C5.21742 14.989 10.4613 19.1828 11.9998 20.3124C13.5387 19.1828 18.7826 14.989 18.7826 10.2991C18.7826 6.5591 15.7398 3.51674 11.9998 3.51674Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LocationIcon;
